import {Component, HostListener, inject, OnDestroy, OnInit} from '@angular/core';
import {routeAnimations} from "./shared/animations/router-animation";
import {Observable} from "rxjs";
import {InactivityTimerService} from "./services/inactivity-timer.service";
import {TranslateService} from "@ngx-translate/core";
import {systemName} from "./store/base.entity";
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    animations: [routeAnimations],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  title = systemName;

  loadingRoute: boolean;
  translate = inject(TranslateService);
  translations: Observable<any>;
  private readonly inactivityTimerService: InactivityTimerService = inject(InactivityTimerService)

  prepareRoute(outlet: RouterOutlet) {
  return outlet.isActivated
    ? outlet.activatedRoute.snapshot.url.join('/') || '/home' // default to 'home'
    : 'void'; // dummy state
}

  ngOnInit(): void {

    this.translate.addLangs(['en', 'sw']);

    const defaultLang = 'en';

    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', defaultLang);
      this.translate.setDefaultLang(defaultLang);
      this.translate.use(defaultLang);
    } else {
      this.translate.use(localStorage.getItem('lang'));
      this.translate.setDefaultLang(localStorage.getItem('lang'));
    }

  }


  ngOnDestroy(): void {
    this.inactivityTimerService.resetTimer();
  }

  @HostListener('document:mousemove')
  @HostListener('document:click')
  @HostListener('document:keypress')
  refreshUserActivity(): void {
    this.inactivityTimerService.refreshUserActivity();
  }
}
